var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    fill: "white",
    stroke: "#636799"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16472_60669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5358 14.7857H21.3215C20.9665 14.7857 20.6786 15.0735 20.6786 15.4286C20.6786 15.7836 20.9665 16.0714 21.3215 16.0714H24.5358C24.8909 16.0714 25.1787 16.3593 25.1787 16.7143V25.0715C25.1787 25.4266 24.8909 25.7144 24.5358 25.7144H11.6786C11.3235 25.7144 11.0357 25.4266 11.0357 25.0715V16.7143C11.0357 16.3592 11.3235 16.0714 11.6786 16.0714H14.8929C15.2479 16.0714 15.5358 15.7836 15.5358 15.4285C15.5358 15.0735 15.2479 14.7856 14.8929 14.7856H11.6786C10.6135 14.7856 9.75 15.6491 9.75 16.7142V25.0714C9.75 26.1366 10.6135 27 11.6786 27H24.5358C25.6009 27 26.4644 26.1366 26.4644 25.0714V16.7143C26.4644 15.6491 25.6009 14.7857 24.5358 14.7857Z",
    fill: "#636799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7759 12.4025L18.5616 9.18823C18.3106 8.93726 17.9036 8.93726 17.6526 9.18823L14.4383 12.4025C14.1916 12.6579 14.1987 13.0649 14.4541 13.3115C14.7032 13.5522 15.0982 13.5522 15.3473 13.3115L17.4643 11.1946V21.8571C17.4643 22.2122 17.7521 22.5 18.1071 22.5C18.4622 22.5 18.75 22.2122 18.75 21.8571V11.1946L20.867 13.3116C21.1224 13.5582 21.5293 13.5511 21.776 13.2957C22.0165 13.0466 22.0165 12.6517 21.7759 12.4025Z",
    fill: "#636799"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16472_60669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintNew);
export default __webpack_public_path__ + "static/media/printNew.4fb87b45.svg";
export { ForwardRef as ReactComponent };